import { SignRequest, TransactionStatus } from '@bitte-ai/types';
import { Transaction } from '@near-wallet-selector/core';
import { Message } from 'ai';

export const createTransactionStatusMessage = (
  transactions: Transaction[],
  status: TransactionStatus,
  hashes: string[],
  error?: string,
  messageId?: string,
): Omit<Message, 'id'> => ({
  role: 'system',
  content: JSON.stringify({
    transactions,
    status,
    message:
      status === 'success'
        ? `Transaction successful! Hash: ${hashes?.length > 0 ? hashes.join(', ') : ''}`
        : status === 'fail'
          ? `Transaction failed: ${error}`
          : 'Transaction pending',
    hashes: hashes,
    messageId,
  }),
});

export const createEvmTransactionStatusMessage = (
  evmData: SignRequest,
  status: TransactionStatus,
  txHash?: string,
  messageId?: string,
  error?: string,
): Omit<Message, 'id'> => ({
  role: 'system',
  content: JSON.stringify({
    status,
    evmData,
    message:
      status === 'success'
        ? `Transaction successful! Hash: ${txHash}`
        : status === 'fail'
          ? `Transaction failed: ${error}`
          : 'Transaction pending',
    txHash,
    messageId,
  }),
});

export const createDeclineTransactionMessage = (
  messageId?: string,
): Omit<Message, 'id'> => ({
  role: 'system',
  content: JSON.stringify({
    message: 'Transaction declined!',
    messageId,
  }),
});
